import { render, staticRenderFns } from "./T2Btn.vue?vue&type=template&id=64d2aca3&scoped=true"
import script from "./T2Btn.vue?vue&type=script&lang=js"
export * from "./T2Btn.vue?vue&type=script&lang=js"
import style0 from "./T2Btn.vue?vue&type=style&index=0&id=64d2aca3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d2aca3",
  null
  
)

export default component.exports